import React from 'react';
import { Trans } from 'react-i18next';
import { Text } from '@user-portal/wikr-components';

import { getSubscriptionTitle } from '../../helpers';

import * as S from '../styled';

import { SubRow } from '../../types';

const PeriodRow = ({ period, isTrial, color }: SubRow) => {
    const paymentLabel = getSubscriptionTitle(period, false);

    return (
        <S.SubscriptionCardRow>
            <Text type="large-text" color={color} medium dataLocator="subscriptionPeriod">
                <Trans
                    i18nKey={isTrial ? 'subscription.period.trial' : 'subscription.period.regular'}
                    values={{
                        count: paymentLabel?.count,
                        context: paymentLabel?.context,
                    }}
                />
            </Text>
        </S.SubscriptionCardRow>
    );
};

export default PeriodRow;
